// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/breadcrumb/breadcrumb-navigation/breadcrumb-navigation.scss
// module id = 515
// module chunks = 0